export default {"src":"/_next/static/media/blog-hero-icon.62ed7c59.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};